import React from "react";
import { useParams } from "react-router-dom";
import { Grid, Typography, Box, Chip, Skeleton } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Back from "../../../common/components/BackNavigateComponent";
import SelectorProvider from "../../customDashboards/common/providers/selectorProvider";
import DatePickerSelector from "./selectors/DatePickerSelector";
import ModuleSelector from "./selectors/ModuleSelector";
import MostVisitedDashboards from "./MostVisitedDashboards";
import ActivityTimeline from "./ActivityTimeline";
import BrowsingPattern from "./BrowsingPattern";
import DashboardVisitTable from "./DashboardVisitTable";
import { useUserList } from "../../../common/API/hooks";
import moment from "moment";

function LastLoginChip({ username }) {
    const { data: userList, isLoading } = useUserList({ username });
    const user = userList?.find?.((u) => u.username === username) ?? userList?.[0];
    const lastLoginTime = user?.last_login;

    if (isLoading) return <Skeleton variant="rounded" width={200} height={24} sx={{ ml: 1 }} />;
    if (!lastLoginTime) return null;

    return (
        <Chip
            icon={<AccessTimeIcon />}
            label={`Last login: ${moment(lastLoginTime).format("YYYY-MM-DD HH:mm")}`}
            size="small"
            variant="outlined"
            color="default"
            sx={{ ml: 1 }}
        />
    );
}

export default function UserUsageAudit() {
    const { username } = useParams();

    return (
        <SelectorProvider>
            <Grid container>
                <Grid sx={{ mt: 3 }} display={"flex"} alignItems="center" flexWrap="wrap" gap={1}>
                    <Back />
                    <Typography variant="h5" style={{ marginLeft: "16px" }}>
                        User Usage Audit
                    </Typography>
                    {username && (
                        <Chip
                            icon={<PersonIcon />}
                            label={username}
                            color="primary"
                            variant="outlined"
                            sx={{ ml: 2, fontWeight: 600 }}
                        />
                    )}
                    {username && <LastLoginChip username={username} />}
                </Grid>

                <Grid item xs={12} sm={12} pt={2}>
                    <Box
                        flexGrow={1}
                        display="flex"
                        xs={12}
                        sx={{ backgroundColor: "#f6f6f8", borderRadius: ".5rem" }}
                        p={2}
                    >
                        <Grid container spacing={2}>
                            <Grid item sm={3} xs={12}>
                                <DatePickerSelector valueKey={"date"} label={"From"} />
                            </Grid>
                            <Grid item sm={3} xs={12}>
                                <DatePickerSelector valueKey={"dateTo"} label={"To"} />
                            </Grid>
                            <Grid item sm={6} xs={12}>
                                <ModuleSelector />
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <MostVisitedDashboards username={username} />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <ActivityTimeline username={username} />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <BrowsingPattern username={username} />
                </Grid>

                <Grid item xs={12} sm={12}>
                    <DashboardVisitTable username={username} />
                </Grid>
            </Grid>
        </SelectorProvider>
    );
}

